import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-FreeEdit",
  "use": "icon-FreeEdit-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-FreeEdit\">\n\t<path d=\"M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM8,4H5V5.53H7.78v.8H5V8.85H4.05V3.15H8Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol